/**
 * @generated SignedSource<<868be3cfe0217ea093e4a716acd152f3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSellerAwayCopy_seller$data = {
  readonly activeTimeAway: {
    readonly endDate: string | null;
  } | null;
  readonly " $fragmentType": "useSellerAwayCopy_seller";
};
export type useSellerAwayCopy_seller$key = {
  readonly " $data"?: useSellerAwayCopy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSellerAwayCopy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSellerAwayCopy_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerTimeAway",
      "kind": "LinkedField",
      "name": "activeTimeAway",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "46fb32a82ca7d0276bcd9e6f7667418d";

export default node;
